import { Card, Dropdown, FloatButton, Pagination, Tooltip } from 'antd'
import React from 'react'
import { DownOutlined, PlusOutlined, LeftOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { formateDate } from 'src/components/helpers/formateDate';
import { deleteClientAbonement, getAbonementsClient, getClientTrainings } from 'src/store/Slices/ClientsSlice';
import { useState } from 'react';
import EditTrainingModal from '../Modals/EditTrainingModal';

const MobileClientsTrainings = ({
    getClientTrainingsList,
    getClientTrainingsListLoading,
    setIsTrainingInfo,
    page,
    setPage,
    setPageSize,
    setTab,
    trainingInfo,
    clientInfo,
    mnemo
}) => {

    const dispatch = useDispatch()

    const [openDeliteAbonementModal, setOpenDeliteAbonementModal] = useState(false)
    const [isOpenAddEditModal, setIsOpenEditModal] = useState(false)


    


    const items = [
        {
            key: '1',
            label: 'Редактировать',
            onClick: () => { setIsOpenEditModal(true) },
            disabled : (!mnemo?.children?.find(el => el.name === 'Таблица тренировок')?.children.find(ele => ele.mnemo === 'updateBtn'))
        },
    ];


    return (
        <>
            <EditTrainingModal
                visible={isOpenAddEditModal}
                setVisible={setIsOpenEditModal}
                trainingInfo={trainingInfo}
                clientInfo={clientInfo}
            />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Pagination
                    defaultCurrent={page}
                    pageSize={20}
                    showSizeChanger={false}
                    current={page}
                    onChange={(page, pageSize) => {
                        dispatch(getClientTrainings({
                            clientId: clientInfo.id,
                            count: pageSize,
                            offset: pageSize * (page - 1),
                        }))
                        setPage(page)
                        setPageSize(pageSize)
                    }}
                    total={getClientTrainingsList?.data?.value?.totalCount}
                    page={page}
                />
                {getClientTrainingsList?.data?.value?.rows.map(element => {
                    return (
                        <Card
                            loading={getClientTrainingsListLoading}
                            title={`Тренировка №: ${element.id}`}
                            extra={<Dropdown
                                menu={{
                                    items,
                                }}
                            >
                                <a onClick={() => {
                                    setIsTrainingInfo({
                                        ...element,
                                        startDate: element.startDate && formateDate(element.startDate),
                                        endDate: element.endDate && formateDate(element.endDate),
                                    })
                                }} className="text-primary text-decoration-none">
                                    Действия <DownOutlined />
                                </a>
                            </Dropdown>}
                            style={{ width: 330, marginTop: 16 }}
                            key={element.id}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    <div>№:</div>
                                    <div>Наименование:</div>
                                    <div>Персональная:</div>
                                    <div>Осталось:</div>
                                    <div>Действует С:</div>
                                    <div>Действует До:</div>
                                </div>
                                <div>
                                    <div>{element?.id ? element?.id : '-'}</div>
                                    <div>{element?.name ? <Tooltip title={element?.name}>{element?.name.slice(0, 15)}</Tooltip> : '-'}</div>
                                    <div>{element?.isPersonal ? 'Да' : 'Нет'}</div>
                                    <div>{element?.trainingsLeft ? element?.trainingsLeft : '-'}</div>
                                    <div>{element?.startDate ? <Tooltip title={element?.startDate}>{formateDate(element?.startDate)}</Tooltip> : '-'}</div>
                                    <div>{element?.endDate ? <Tooltip title={element?.endDate}>{formateDate(element?.endDate)}</Tooltip> : '-'}</div>
                                </div>
                            </div>
                        </Card>
                    )
                })}
                {/* <FloatButton
                    style={{ right: 24 }}
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                        setIsOpenAddEditModal({ open: true, flag: 'add' })
                    }}
                /> */}
                <FloatButton
                    style={{ left: 24 }}
                    type="primary"
                    icon={<LeftOutlined />}
                    onClick={() => { setTab('Клиенты') }}
                />
            </div>
        </>
    )
}

export default MobileClientsTrainings